import { render, staticRenderFns } from "./StocktakingStatisticView.vue?vue&type=template&id=62ddf7d1&"
import script from "./StocktakingStatisticView.vue?vue&type=script&lang=js&"
export * from "./StocktakingStatisticView.vue?vue&type=script&lang=js&"
import style0 from "./StocktakingStatisticView.vue?vue&type=style&index=0&id=62ddf7d1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports